import { create } from "zustand"

export const useFocusMode = create(set => ({
  animate: true,
  inFocusMode: false,
  toggle: () =>
    set(state => ({
      inFocusMode: !state.inFocusMode
    })),
  enter: () => set({ inFocusMode: true }),
  exit: () => set({ inFocusMode: false }),

  toggleAnimate: enabled =>
    set(state => ({
      animate: enabled !== undefined ? enabled : !state.animate
    }))
}))
